module.exports = __webpack_public_path__ + "img/apple.4ca6a5c2.png";